import { Suspense, ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { Loading, Login } from '../../lib';
import { getAsyncHook } from '@weapp/utils';

function Coms(props: any) {
    const hook = getAsyncHook('weappPassportWeb', 'beforLoginRender');
    if (hook) {
        hook(0)
    }
    return (
        <>
            <Suspense weId={`${props.weId || ''}_6d6ath`} fallback={<Loading weId={`${props.weId || ''}_v5j38t`} />}>
                <Login weId={`${props.weId || ''}_pylpnk`} />
            </Suspense>
        </>
    )
}
function RouteLogin(props: RouteComponentProps & ComponentProps<any>) {
    const parentPath: string = fomatParentPath(props);
    return (
        <>
            <Route weId={`${props.weId || ''}_712j6g`} exact path={`${parentPath}/`} component={Coms} />
            <Route weId={`${props.weId || ''}_6p6nql`} exact path={`${parentPath}/login`} component={Coms} />
            <Route weId={`${props.weId || ''}_6p6nql`} exact path={`${parentPath}/customlogin/:customPath`} component={Coms} />
        </>
    )
}
export default withRouter(RouteLogin);
